import { Form, Formik } from 'formik';
import * as bd from 'react-basic-design';
import { CustomerDTO } from '../../../api/customer-api';
import SvgClose from '../../../assets/icons/Close';
import SvgDelete from '../../../assets/icons/Delete';
import SvgSave from '../../../assets/icons/Save';
import { BasicModal } from '../../../components/basic/basic-modal';
import { T } from '../../../components/basic/text';
import { yup } from '../../../components/basic/yup';
import { FormikTextField } from '../../../components/formik';

interface SaveCustomerModalProps {
    show: boolean;
    allowEdit: boolean;
    selectedCustomer?: CustomerDTO;
    onHide: () => void;
    onSave: (values: CustomerDTO) => void;
    onDelete?: (customer: CustomerDTO) => void;
}

export function SaveCustomerModal({
    show,
    allowEdit,
    selectedCustomer,
    onHide,
    onSave,
    onDelete,
}: SaveCustomerModalProps) {
    const CustomerSchema = yup.object().shape({
        firstName: yup.string().required(' '),
        lastName: yup.string().required(' '),
    });

    const defaultValues: CustomerDTO = {
        id: selectedCustomer?.id,

        firstName: selectedCustomer?.firstName || '',
        lastName: selectedCustomer?.lastName || '',
        nationalCode: selectedCustomer?.nationalCode || '',
        companyName: selectedCustomer?.companyName || undefined,
        nationalId: selectedCustomer?.nationalId || undefined,
        phoneNumber: selectedCustomer?.phoneNumber || undefined,
    };

    if (!show) return <></>;

    return (
        <Formik initialValues={defaultValues} validationSchema={CustomerSchema} onSubmit={onSave}>
            {formik => (
                <BasicModal
                    show={show}
                    onHide={onHide}
                    title={
                        <bd.Flex className="w-100" align="center" content="between">
                            <T>{selectedCustomer ? 'edit-customer' : 'new-customer'}</T>
                            <bd.Flex align="center" gap={2}>
                                <bd.Button
                                    variant="icon"
                                    size="sm"
                                    onClick={formik.submitForm}
                                    disabled={!allowEdit}
                                >
                                    <SvgSave />
                                </bd.Button>
                                {selectedCustomer && onDelete && (
                                    <bd.Button
                                        disabled={!allowEdit}
                                        variant="icon"
                                        color="secondary"
                                        size="sm"
                                        onClick={() => onDelete(selectedCustomer)}
                                    >
                                        <SvgDelete />
                                    </bd.Button>
                                )}
                                <bd.Button
                                    disabled={!allowEdit}
                                    variant="icon"
                                    color="secondary"
                                    size="sm"
                                    onClick={onHide}
                                >
                                    <SvgClose />
                                </bd.Button>
                            </bd.Flex>
                        </bd.Flex>
                    }
                >
                    <Form>
                        <bd.Flex align="center" wrap>
                            <FormikTextField
                                label="first-name"
                                name="firstName"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="last-name"
                                name="lastName"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="phone-number"
                                name="phoneNumber"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="national-code"
                                name="nationalCode"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="company-name"
                                name="companyName"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="national-id"
                                name="nationalId"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />
                        </bd.Flex>
                    </Form>
                </BasicModal>
            )}
        </Formik>
    );
}
